import React from 'react';
import './Blog.css';

import BlogImage from '../img/MacBook Mockup, Floating.png';

const Blog = () => {
    return (
        <section className="blog container section" id="blog">
            <h2 className="section__title">Latest Posts</h2>

            <div className="blog__container grid">
                <div className="blog__card">
                    <div className="blog__thumb">
                        <a href="https://lnkd.in/p/eSfErsGi" target="_blank" rel="noreferrer"><span className="blog__category">Award</span></a>
                        <a href="https://lnkd.in/p/eSfErsGi" target="_blank" rel="noreferrer"><img src="/incubation.png" alt="IT Park Incubation Demo Day" className='blog__img' /></a>
                    </div>
                    <div className="blog__details">
                        <h3 className="blog__title">1st Place at IT Park Incubation Demo Day!</h3>
                        <div className="blog__meta">
                            <span>4 May, 2026</span>
                            <span className="blog__dot">.</span>
                            <span>Ahrorbek Khalimov</span>
                        </div>
                    </div>
                </div>

                <div className="blog__card">
                    <div className="blog__thumb">
                        <a href="https://t.me/itzmon1ycold" target="_blank" rel="noreferrer"><span className="blog__category">Launch</span></a>
                        <a href="https://t.me/itzmon1ycold" target="_blank" rel="noreferrer"><img src={BlogImage} alt="IELTSPRACTICE Launch" className='blog__img' /></a>
                    </div>
                    <div className="blog__details">
                        <h3 className="blog__title">After 4 months of hard work, IELTSPRACTICE has been finally launched</h3>
                        <div className="blog__meta">
                            <span>22 April, 2025</span>
                            <span className="blog__dot">.</span>
                            <span>Ahrorbek Khalimov</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Blog